import { RealtimeRepository } from "@api/repositories/reatime-repository/RealtimeRepository";
import { Observers, RealtimeMessageModel, SignalRMethod } from "@api/repositories/reatime-repository/types";
import { parseJson } from "@common/TypesHelper";
import { Element } from "@api/models/Element";
import { ExhibitionsListHelper } from "@service/store/events/exhibitions/ExhibitionsListHelper";
import store from "@service/store";

//@todo think of universal observers registrator
export class ExhibitionsObserver {
    private readonly observers: Observers;

    constructor(
        private readonly realtimeRepository: RealtimeRepository,
        private readonly exhibitions: ExhibitionsListHelper
    ) {
        this.observers = {
            [`objects.${this.exhibitions.schemaId}.${store.getters['language']}`]: {
                [SignalRMethod.objectUpdated]: this.handler.bind(this)
            }
        }
    }

    private async handler(data: any): Promise<void> {
        const update = parseJson(data) as RealtimeMessageModel;

        const newElement = new Element(update.data, this.exhibitions.schemaId);

        if (newElement.isDeleted) {
            this.exhibitions.delete(newElement.eventId, newElement.id);
            return;
        }

        this.exhibitions.update(newElement);
    }

    async connect() {
        try {
            await this.realtimeRepository.attach(this.observers);
        }
        catch (e) {
            store.dispatch('reportError', e);
        }
    }
}
